import React from 'react';

import { images } from '../../constants'
import { SubHeading } from '../../components';

const FindUs = () => {
  return (
    <div className="app__bg app__wrapper section__padding">
      <div className="app__wrapper_info">
        <SubHeading title="Contact" />
        <h1 className="headtext__cormorant" style={{ marginBottom: '3rem', color: 'var(--color-golden)'}}>Find Us</h1>
        <div className="app__wrapper-content">
          <p className="p__opensans">1845 Prospect St, Pretoria, Gauteng, South Africa </p>
          <p className="p__cormorant" style={{color:'#DCCA87', margin:'2rem 0'}}>Opening Hours:</p>
          <p className="p__opensans">Mon - Fri: 10am to 12am </p>
          <p className="p__opensans">Sat - Sun: 11am to 9pm</p>
        </div>
        <button className="custom__button" type='button' style={{margin:'2rem'}}> VIsit Us</button>

      </div>

      <div className="app__wrapper_img">
        <img src={images.findus} alt="Find Us" />
      </div>
    </div>
  )
}

export default FindUs;
